<template>
    <div class="create-layout-wrapper">
        <h1>Layout bearbeiten</h1>
        <LayoutForm :mode="'edit'" v-if="loaded" v-model="model"></LayoutForm>
        <AdaButton style="width: 100%" title="Layout aktualisieren" @click="updateLayout" icon="icon-add"
                   type="fullWidthButton"></AdaButton>
    </div>
</template>

<script>

    import AdaButton from "../components/AdaButton";
    import {RepositoryFactory} from "../scripts/RepositoryFactory";
    import LayoutForm from "../components/LayoutForm";

    const LayoutRepository = RepositoryFactory.get('layouts');

    export default {
        name: "EditLayout",
        components: {
            AdaButton,
            LayoutForm
        },
        data: function () {
            return {
                model: {},
                loaded: false
            }
        },
        computed: {},
        methods: {
            async updateLayout() {
                try {
                    await LayoutRepository.updateLayout(this.$route.params.id, this.model);
                    this.$noty.success("Das Layout wurde erfolgreich aktualisiert.");
                    await this.$router.push('/layouts');
                } catch (e) {
                    this.$noty.error("Fehler bei der Erstellung: \n" + e.response.data.error);
                }
            },
            async getLayout() {
                try {
                    const {data} = await LayoutRepository.getOne(this.$route.params.id);
                    this.model = data;
                    this.model.subtext = 'An diese Stelle erfolgt eine Ausfüllanweisung';
                    this.loaded = true;
                } catch (e) {
                    this.$noty.error("Fehler beim Laden des Layouts: \n" + e.response.data.error);
                }
            }
        },
        mounted() {
            this.getLayout();
        }
    }
</script>
<style lang="scss" scoped>

    .create-layout-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 800px;
    }

    .create-form {
        width: 800px;
    }

    .create-form > div {
        margin-bottom: 20px;
    }

    .split-div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

</style>